export const PURCHASE = 'Purchase/Sale';
export const LISTING = 'Listing';
export const LEASE = 'Lease';
export const LEASE_LISTING = 'Lease-Listing';
export const BUYER = 'Buyer';
export const SELLER = 'Seller';
export const INVALID_PHONE_NUMBER = 'Please enter a valid phone number';

export const RESIDENTIAL = 'Residential';
export const COMMERCIAL = 'Commercial';
export const INDUSTRIAL = 'Industrial';
export const VACANT_LAND = 'Vacant Land';
export const MULTI_UNIT = 'Multi Unit';
export const FARM_AND_RANCH = 'Farm and Ranch';
export const CONDOMINIUM = 'Condominium';
export const MANUFACTURED_HOME = 'Manufactured Home';
export const COOP = 'Coop';
export const UNLISTED = 'Unlisted';
export const OTHER = 'Other';
export const KEY_TD_CONNECTION_STATUS = 'td_connection_status';
export const KEY_TD_INTEGRATION_STATUS = 'td_integration_status';
export const TD_TYPE_TAKE_LIMIT = 50;

export const PROPERTY_TYPES = [
  RESIDENTIAL,
  COMMERCIAL,
  INDUSTRIAL,
  VACANT_LAND,
  MULTI_UNIT,
  FARM_AND_RANCH,
  CONDOMINIUM,
  MANUFACTURED_HOME,
  COOP,
  UNLISTED,
  OTHER,
];
export const TRANSACTION_TYPES = [PURCHASE, LISTING, LEASE, LEASE_LISTING];

export const TRANSACTION_TYPE_VALUES = {
  [LISTING]: 0,
  [PURCHASE]: 1,
  [LEASE]: 2,
  [LEASE_LISTING]: 3,
};

export const PROPERTY_TYPE_VALUES = {
  [RESIDENTIAL]: 0,
  [COMMERCIAL]: 1,
  [INDUSTRIAL]: 2,
  [VACANT_LAND]: 3,
  [MULTI_UNIT]: 4,
  [FARM_AND_RANCH]: 5,
  [CONDOMINIUM]: 6,
  [MANUFACTURED_HOME]: 7,
  [COOP]: 8,
  [UNLISTED]: 9,
  [OTHER]: 10,
};

export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};


export const CONNECTION_STATUS_TD = {
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};

